import { CRM_COUNTRIES, localStorageKeys } from "../helpers/constants";
import { getSelectedCoutryCode } from "../helpers/url";
import ExtendedSelect from "./ExtendedSelect";

export default () => {
  const options = CRM_COUNTRIES.map((el) => ({
    name: el.name,
    value: el.code,
  }));

  const handleOnChange = (value) => {
    console.log(value);
    localStorage.setItem(localStorageKeys.selectedCountry, value);
    window.location.reload();
  };

  const initialValue = getSelectedCoutryCode();

  return (
    <ExtendedSelect
      label="Select country"
      onChange={(e) => handleOnChange(e.target.value)}
      value={initialValue}
      options={options}
    />
  );
};
